<template>
  <form>
    <v-row class="form">
      <v-col
          cols="12"
          md="12"
          v-for="(item, index) in formItem"
          :key="index"
      >
        <div class="field">
          <label class="label">{{ getTranslatedText(item.label) }}</label>
          <div class="control">
            <input
              v-if="item.type === 'password'"
              :class="item.className ? item.className : 'input-text'"
              :type="item.type"
              :value="dataForm[`${item.name}`]"
              pattern="[0-9]*"
              inputmode="numeric"
              :required="item.required"
              @input="(value) => onChangeValue(value, item.name)"
            />
            <input
              v-if="item.type === 'text'"
              :class="item.className ? item.className : 'input-text'"
              :type="item.type"
              :value="dataForm[`${item.name}`]"
              :required="item.required"
              :pattern="item.pattern"
              :inputmode="item.inputmode"
              @input="(value) => onChangeValue(value, item.name)"
            />
            <input
              v-if="item.type === 'number'"
              :class="item.className ? item.className : 'input-text'"
              :value="dataForm[`${item.name}`]"
              :required="item.required"
              :pattern="item.pattern"
              :inputmode="item.inputmode"
              :maxlength="item.maxlength"
              @input="
                (value) => onChangeValue(value, item.name, item.maxlength, item.type)
              "
              @paste="handlePaste($event, item.name, item.maxlength)"
            />
            <PasswordInput
              v-if="item.type === 'otp'"
              :length="item.otp_length"
              :type="item.otp_type"
              :class="item.className ? item.className : 'input-otp'"
              :required="item.required"
              @keydown="onChangeOTP"
              pattern="[0-9]*"
              inputmode="numeric"
              @input="(value) => onChangeValue(value, item.name)"
            ></PasswordInput>
          </div>
        </div>
      </v-col>
    </v-row>
  </form>
</template>

<script>
import languageMixins from "@/mixins/language/language-mixins";
import { isStrEmpty } from "@/utils/utils";
import EventBus from "@/utils/EventBus";
import PasswordInput from "./password-input.vue";

export default {
  mixins: [languageMixins],
  components: {
    PasswordInput
  },
  props: {
    formItem: {
      type: Array,
      default: () => [],
    },
    dataForm: {
      type: Object,
      default: () => {
        return {};
      },
    },
    nameFunction: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  methods: {
    onChangeValue(event, name, maxlength, type) {
      let valueChanged = event.target?.value;
      let valueNotChange = event.target?.value.slice(0, -1);
      if (event?.data?.replace(/\D/g, "") === "" && type === "number") {
        event.target.value = valueNotChange;
      }
      const param = { event, name };
      if (maxlength && valueChanged.length > maxlength) {
        event.target.value = parseInt(valueChanged.toString().slice(0, maxlength));
      }
      if (!isStrEmpty(this.nameFunction)) {
        EventBus.$emit(this.nameFunction, param);
      }
    },
    onChangeOTP(event) {
      const keyCode = event.keyCode;
      const key = event.key;

      if (!isNaN(key) || keyCode === 8 || keyCode === 9) {
        // Handling logic when entering numbers, or the Backspace (8) and Tab (9) keys
      } else {
        event.preventDefault();
      }
    },
    handlePaste(event, name, maxlength){
      event.preventDefault();
      const pastedData = event.clipboardData.getData('text/plain');
      const onlyNumbers = pastedData.replace(/\D/g, '');
      event.target.value = onlyNumbers
      const param = { event, name };
      if (maxlength && onlyNumbers.length > maxlength) {
        event.target.value = parseInt(onlyNumbers.toString().slice(0, maxlength));
      }
      if (!isStrEmpty(this.nameFunction)) {
        EventBus.$emit(this.nameFunction, param);
      }
    }
  },
};
</script>

<style lang="scss">
@import "~ThemePath/scss/common/_form.scss";
</style>
